<template>
	<div v-if="value">
		<div class="flex">
			<div class="flex flex-grow flex-wrap w-1 mr-4">
				<BaseSelect
					:required="required"
					:label="$t('greeting')"
					:options="getTitles"
					v-model="genderSelection"
					v-if="showTitleRow"
					@input="customerChanged"
					ref="BaseSelect-Title"
					:allow-empty="true"
					class="w-1/2 mr-4"
					:disabled="disabled"
				/>
				<BaseInput
					:label="$t('title')"
					v-if="showTitleRow"
					v-model="value.title"
					@input="customerChanged"
					ref="BaseSelect-Prefix"
					:disabled="disabled"
					class="flex-grow pl-0"
				/>
			</div>
			<div class="flex-grow w-1 hidden md:block"></div>
		</div>
		<div class="flex flex-wrap">
			<BaseInput
				ref="BaseInput-firstname"
				:required="!isCompany && required"
				class="flex-grow pr-0"
				:label="$t('first_name')"
				:placeholder="$t('first_name')"
				type="text"
				@input="customerChanged"
				v-model="value.firstName"
				:disabled="disabled"
			/>
			<BaseInput
				ref="BaseInput-lastname"
				:required="!isCompany && required"
				class="flex-grow pl-0 md:pl-4"
				:label="$t('last_name')"
				:placeholder="$t('last_name')"
				type="text"
				@input="customerChanged"
				v-model="value.lastName"
				:disabled="disabled"
			/>
		</div>
		<div class="flex" v-if="showCompany">
			<BaseInput
				ref="BaseInput-companyname"
				class="md:w-1/2 pl-0 md:mr-4"
				:label="$t('company_name')"
				:placeholder="$t('company_name')"
				type="text"
				@input="customerChanged"
				:required="isCompany"
				v-model="value.company.name"
				v-if="value && value.company"
				:disabled="disabled"
			/>
			<div class="md:w-1/2 pl-0 md:pl-4"></div>
		</div>
	</div>
</template>
<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import Validate from '@/mixins/Validate';
import { getPersonTitlesOption, getPersonTitlesOptions } from '@/plugins/Utils';

export default {
	name: 'PersonNameForm',
	components: { BaseInput, BaseSelect },
	mixins: [Validate],
	props: {
		value: {},
		showCompany: { type: Boolean, default: true },
		disabled: { default: false },
		required: {
			default: true,
		},
		showTitleRow: { required: false },
	},
	data() {
		return {
			genderSelection: '',
		};
	},
	methods: {
		clear() {
			this.genderSelection = '';
		},
		customerChanged() {
			this.value.gender = this.genderSelection ? this.genderSelection.value : this.getTitles[0].value;
			if (this.value.company?.name) {
				this.value.gender = 'company';
			}
			this.$emit('input', this.value);
		},
	},
	computed: {
		getTitles() {
			if (!this.showCompany) {
				return getPersonTitlesOptions().filter(option => option.value !== 'company');
			}
			return getPersonTitlesOptions();
		},
		isCompany() {
			if (!this.showCompany) {
				return false;
			}
			if (this.value.company.name) {
				return true;
			} else {
				return this.genderSelection === undefined ? false : this.genderSelection !== '' && this.genderSelection.value === 'company';
			}
		},
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				if (this.value?.gender) {
					this.genderSelection = getPersonTitlesOption(this.value.gender);
				}

				if (this.value && !this.value?.company && this.showCompany) {
					this.value.company = {};
				}
			},
		},
	},
};
</script>
